<script setup lang="ts">
import { ref, watch } from 'vue'

import { Switch } from '@collector/shared-ui'
import { ExtractStrict } from '@collector/shared-utils'
import { EventSettingsRecordUpdate } from '@desktop/utils/database'
import { useEventSettings } from '@desktop/views/Relation/composables'

import { injectSuccessBadge } from '../../successBadge'

interface Props {
  settingName: ExtractStrict<
    keyof EventSettingsRecordUpdate,
    | 'shotsCoordinates'
    | 'teamColorsSwitched'
    | 'assignPlayerOnPitch'
    | 'invertedParticipants'
  >
}

const props = defineProps<Props>()

// inject
const { showSuccessBadge } = injectSuccessBadge()

// composables
const { eventSettings, updateEventSettings } = useEventSettings()

// state
const value = ref<boolean>(!!eventSettings.value[props.settingName])

// init
watch(value, (newValue) => {
  updateEventSettings({ [props.settingName]: newValue })

  showSuccessBadge()
})
</script>

<template>
  <Switch
    v-model="value"
    size="xs"
  >
    <slot />
  </Switch>
</template>
